import { F0Button } from '@factorialco/f0-react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

interface SessionActionButtonProps {
  connected: boolean
  connecting: boolean
  onConnect: () => void
  onDisconnect: () => void
}

export const SessionActionButton = ({
  connected,
  connecting,
  onConnect,
  onDisconnect,
}: SessionActionButtonProps) => {
  if (connected) {
    return (
      <F0Button
        label={i18n.t('common.ai.voice.control_bar.session.end')}
        onClick={() => {
          track(trackingEvents.meetings.ControlBarLeaveButton)
          onDisconnect()
        }}
        size="md"
        variant="default"
      />
    )
  }

  return (
    <F0Button
      label={i18n.t('common.ai.voice.control_bar.session.start')}
      loading={connecting}
      disabled={connecting}
      onClick={onConnect}
      size="md"
      variant="default"
    />
  )
}
